module.exports = __webpack_public_path__ + "img/18.7af4a5f3.svg";